import classNames from 'classnames'
import { Badge, PricingTreatment, PromoMessage, StoreIcons } from 'baby-design'
import { useWindowSize } from 'usehooks-ts'

import { BREAKPOINT_TABLET } from 'src/constants'
import { RegItemMinimalCardDetailsProps } from '../RegItemMinimalCardDetails.types'
import css from '../RegItemMinimalCardDetails.styles.scss'
import {
  getSaleBadgeLabel,
  getPricingData,
  isRegItemOnSale,
  isRegItemOutOfStock,
} from '../RegItemMinimalCardDetails.utils'

const ProductDetails: React.FC<RegItemMinimalCardDetailsProps> = ({
  regItem,
}: RegItemMinimalCardDetailsProps) => {
  const { width: windowWidth } = useWindowSize()
  const isMobile = windowWidth < BREAKPOINT_TABLET
  const { title } = regItem
  const wrapperClasses = classNames(
    css.RegItemMinimalCardDetails,
    css.ProductDetails
  )
  const storesIconsMap = (regItem.offers || []).map((offer) => ({
    name: offer.storeIconName,
  }))
  const { priceRange, strikePrice, price } = getPricingData(regItem)
  const isOutOfStock = isRegItemOutOfStock(regItem)
  const isOnSale = isRegItemOnSale(regItem)
  const saleBadgeLabel = getSaleBadgeLabel(regItem)

  return (
    <div className={wrapperClasses} data-testid="ProductDetails">
      <div className={css.Title}>{title}</div>
      <StoreIcons
        size={isMobile ? 'small' : 'medium'}
        stores={storesIconsMap}
      />
      <div className={css.Pricing}>
        <PricingTreatment
          price={price}
          priceRange={priceRange}
          saleVariant={isOnSale ? 'red' : 'default'}
          size={isMobile ? 'md' : 'lg'}
          strikePrice={strikePrice}
        />
        {isOnSale && (
          <Badge
            fill="discount-ruby"
            label={saleBadgeLabel}
            size={isMobile ? 'small' : 'medium'}
            variant="promo"
          />
        )}
        {regItem.priceDetails?.saleAttributes?.saleCallouts?.map(
          ({ type, text }) => {
            if (type !== 'text') return null

            return (
              <div className={css.SaleCallout}>
                <PromoMessage
                  key={text}
                  size={isMobile ? 'xs' : 'sm'}
                  text={text}
                />
              </div>
            )
          }
        )}
      </div>
      {isOutOfStock && (
        <div>
          <Badge
            dangerouslyOverrideClassName={css.Badge}
            fill="gray"
            label="Out of stock"
            size={isMobile ? 'small' : 'medium'}
            variant="promo"
          />
        </div>
      )}
    </div>
  )
}

export default ProductDetails
